module.exports = __webpack_public_path__ + "assets/img/btn-detail-e77a4efb.png";